import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AboutPage from "@/pages/AboutPage";

export const Route = createFileRoute("/about")({
  head: () => pageHead("About Us", "Learn about AKIVA, founded in 2017, an AI-native engineering firm delivering enterprise services and AI solutions for government and commercial clients.", "/about", false),
  component: AboutPage,
});
